import { type WorkspaceAgentOnboardingRole } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentOnboardingHandoff';
import { parseWorkspaceAgentOnboardingRoleSearch } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentOnboardingRoleHandoff';
import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { useRouterSelector } from '~/hooks/useRouterSelector';

export const useWorkspaceAgentOnboardingRole = (): { role: WorkspaceAgentOnboardingRole | null } => {
  const handoffRole = useWorkspaceAgentPanelStore((state) => state.onboardingHandoff?.role ?? null);
  const roleFromUrl = useRouterSelector((location) => parseWorkspaceAgentOnboardingRoleSearch(location.search));

  return { role: handoffRole ?? roleFromUrl ?? null };
};
